<template>
  <UPageSection
    v-if="items.length"
    :title="title"
    :ui="{
      title: 'text-2xl font-bold sm:text-3xl',
      container: 'py-10 sm:py-12',
    }"
  >
    <ul class="grid gap-3 lg:max-w-3xl">
      <li
        v-for="(item, index) in items"
        :key="index"
        class="flex gap-3 rounded-xl border border-default/50 bg-elevated/40 px-4 py-3.5"
      >
        <UIcon name="i-heroicons-academic-cap" class="mt-0.5 size-5 shrink-0 text-primary" />
        <span class="text-sm leading-relaxed text-muted sm:text-base">{{ itemText(item) }}</span>
      </li>
    </ul>
  </UPageSection>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    title?: string
    items?: Array<string | { text?: string }>
  }>(),
  {
    items: () => [],
  },
)

function itemText(item: string | { text?: string }): string {
  if (typeof item === 'string') return item
  return item.text ?? ''
}
</script>
